module.exports = __webpack_public_path__ + "3203d3559ab28a0b55b6f6861cf9a072.svg";